import fetch from '../utils/fetch';

const requestAction = endpoint => (emailAddress, signInId) => fetch(endpoint, {
  method: 'post',
  body: JSON.stringify({ Username: emailAddress, signInId })
});

export const requestResetPassword = requestAction('/core/resetpassword/request');
export const requestSetPassword = requestAction('/core/setpassword/request');
